<template>
    <div class="bg-yellow-50 shadow mt-5 p-5" id="transfer-receipt">
        <table class="w-full">
            <tbody>
            <tr>
                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                    <application-mark width="150" class="m-auto" style="-webkit-filter: grayscale(100%);"/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                DADOS DO PAGADOR
            </td>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Nome</td>
                <td class="px-2 py-2 text-sm text-right">
                    MILANEZ & MILANEZE S/A
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Agência</td>
                <td class="px-2 py-2 text-sm text-right">
                    0001
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Conta</td>
                <td class="px-2 py-2 text-sm text-right">
                    10956-1
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                    BENEFICIARIO
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm text-center" colspan="2">
                    <span class="font-bold">MONEY PLUS SCMEPP LTDA</span><br/>
                    <span class="text-3xl font-extrabold">
                                        R$ {{ 253.78 | currency }}</span>

                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Documento</td>
                <td class="px-2 py-2 text-sm text-right">11.581.339/0001-45
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Data Vencimento</td>
                <td class="px-2 py-2 text-sm text-right">29/05/2021</td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Desconto/Abatimento</td>
                <td class="px-2 py-2 text-sm text-right">
                    {{ 0 | currency }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Juros/Multa</td>
                <td class="px-2 py-2 text-sm text-right">{{0 | currency  }}
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-sm font-bold">Valor Pagamento</td>
                <td class="px-2 py-2 text-sm text-right">253.78</td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-xs text-center" colspan="2">
                    <hr/>
                </td>
            </tr>
            <tr>
                <td class="px-2 py-2 text-center" colspan="2">
                    <span class="text-bold">Autenticação</span><br/>
                    <span class="text-xs">af072c6e-9e20-4f70-953a-f2b676082eef</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ApplicationMark from "../../Jetstream/ApplicationMark";

export default {
    props: {
        content: {
            type: Object,
            default: {}
        },
        account: {
            type: Object,
            default: {}
        }
    },
    methods: {
        parseType: function (type) {
            switch (type) {
                case 'ted':
                    return 'ENVIO TED';
                case 'p2p':
                case 'transferencia':
                    return 'ENTRE CONTAS DÉBITO';
                default:
                    return type;
            }
        }
    },
    data() {
        return {}
    },
    components: {
        ApplicationMark
    },
}
</script>
